import React from 'react';

const GoogleLogo = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 12 13">
        <path
            fill="#4285F4"
            d="M6.122 5.01v2.37h3.295a2.823 2.823 0 01-1.23 1.843l1.987 1.541C11.332 9.697 12 8.127 12 6.263a7.03 7.03 0 00-.111-1.253H6.122z"
        />
        <path
            fill="#34A853"
            d="M2.691 7.288l-.448.343L.657 8.867a6.122 6.122 0 005.465 3.378c1.653 0 3.04-.545 4.052-1.48L8.187 9.223c-.545.367-1.24.59-2.065.59-1.591 0-2.944-1.074-3.428-2.522l-.003-.003z"
        />
        <path
            fill="#FBBC05"
            d="M.657 3.378A6.047 6.047 0 000 6.122c0 .99.24 1.92.657 2.744 0 .006 2.037-1.58 2.037-1.58a3.669 3.669 0 01-.195-1.164c0-.406.072-.796.195-1.163L.657 3.379z"
        />
        <path
            fill="#EA4335"
            d="M6.123 2.438c.901 0 1.703.312 2.343.913l1.753-1.754C9.156.607 7.776 0 6.123 0A6.112 6.112 0 00.657 3.379l2.037 1.58c.484-1.447 1.837-2.521 3.429-2.521z"
        />
    </svg>
);

export default GoogleLogo;
